import React from 'react';

interface AddUserProps {
  className?: string;
  width?: number;
  height?: number;
}

const AddUserIcon = function AddUserIcon({
  className,
  width,
  height,
}: AddUserProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 22 22"
    >
      <circle cx="7.5" cy="6" r="3.75" fill="white" />
      <path d="M14.25 7.5L14.25 12" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M16.5 9.75L12 9.75" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <path d="M12.8566 15.2869C13.2028 15.2085 13.4105 14.8486 13.257 14.5285C12.8432 13.6652 12.163 12.9066 11.2814 12.3349C10.1966 11.6313 8.8674 11.25 7.5 11.25C6.1326 11.25 4.80341 11.6313 3.71858 12.3349C2.837 12.9066 2.15682 13.6652 1.74297 14.5284C1.58951 14.8486 1.79718 15.2085 2.1434 15.2869C5.66981 16.0855 9.33019 16.0855 12.8566 15.2869Z" fill="white" />
    </svg>
  );
};

AddUserIcon.defaultProps = {
  className: '',
  width: 22,
  height: 22,
};

export default AddUserIcon;
